import { UIEventHandler, useState } from "react";
import { Modal, ModalProps } from "../Modal/Modal";
import { Button } from "../Button/Button";

import styles from "./PersonalDataModal.module.scss";
import { IconButton, Modal as ModalNew, Button as ButtonNew } from "../../../../../shared/ui";
import { useMediaQuery } from "../../../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../../shared/constants/media";

import css from "../../../../../entities/Vacancy/ui/VacancyOfferForm/VacancyOfferForm.module.scss";

interface PersonalDataAgreementModalProps extends ModalProps {
    onAccept: () => void;
    isNew?: boolean;
}

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md);

export const PersonalDataAgreementModal = (props: PersonalDataAgreementModalProps) => {
    const { children, onClose, status, onAccept, isNew } = props;
    const isMobile = useMediaQuery(mediaQuery);
    const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false);

    const handleScroll: UIEventHandler<HTMLDivElement> = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target as HTMLDivElement;
        if (scrollTop + clientHeight >= scrollHeight - 200) {
            setHasScrolledToEnd(true);
        }
    };

    const handleAccept = () => {
        onAccept();
        onClose();
    };

    return isNew ? (
        <ModalNew isOpen={status}>
            <section className={styles.modal}>
                {isMobile ? (
                    <>
                        <button onClick={onClose} className={css.backButton}></button>
                        <button onClick={onClose} className={css.burger}></button>
                    </>
                ) : (
                    <IconButton icon="close" theme="white" onClick={onClose} className={css.close} />
                )}
                <div className={styles.content}>
                    <h3 className={styles.title}>
                        Согласие субъекта персональных данных на обработку персональных данных
                    </h3>
                    <div className={styles.personalDataAgreementModal__content} onScroll={handleScroll}>
                        {children}
                    </div>
                    <div>
                        <ButtonNew
                            as="button"
                            className={styles.offerButton}
                            isDisabled={!hasScrolledToEnd}
                            onClick={handleAccept}
                            size="s"
                        >
                            Принять
                        </ButtonNew>
                    </div>
                </div>
            </section>
        </ModalNew>
    ) : (
        <Modal status={status} onClose={onClose}>
            <div className={styles.personalDataAgreementModal}>
                <button onClick={onClose} type={"button"} className={styles.personalDataAgreementModal__close}></button>
                <h2>Согласие субъекта персональных данных на обработку персональных данных</h2>
                <div className={styles.personalDataAgreementModal__content} onScroll={handleScroll}>
                    {children}
                </div>
                <div className={styles.personalDataAgreementModal__buttonsWrapper}>
                    <Button circle={false} disabled={!hasScrolledToEnd} onClick={handleAccept}>
                        Принять
                    </Button>
                    <Button circle={false} theme={"other"} onClick={onClose}>
                        Закрыть
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
